module.exports = __webpack_public_path__ + "img/lqsxback_1.d3649441.svg";